import Button from "../Button";
import React from "react";
import { generalIcons, walletIcons } from "../../utils/constants";
import { getTruncatedAddress } from "../../utils/helper";

export default function LogoutButton({
  className = "",
  walletAddress,
  connectedWallet,
  disconnectWallet,
}) {
  return (
    <Button
      id="disconnect"
      className={`relative bg-white/[.06] backdrop-blur-[10px] border-[1.5px] border-white/10 text-white px-3 py-2 md:px-5 md:py-[12px] laptop:text-xsm xxl:text-base leading-tight group w-fit ${className}`}
    >
      <span className="mr-[10px] w-[17px] h-[17px] *:w-full *:h-full">
        {walletIcons[connectedWallet]?.("max-w-full max-h-full object-cover")}
      </span>
      {getTruncatedAddress(walletAddress)}

      <div
        className="group-hover:flex opacity-0 lg:group-hover:opacity-100 items-center justify-center gap-2 absolute top-0 left-0 w-full h-full rounded-full bg-blurHover bg-no-repeat bg-cover bg-center"
        onClick={disconnectWallet}
      >
        <span className="w-[14px] h-[14px] flex items-center justify-center">
          {generalIcons.disconnectWallet}
        </span>
        Disconnect
      </div>
    </Button>
  );
}
